<template>
  <svg v-if="small" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M7.9751 4.6001H6.7601C6.00403 4.6001 5.62599 4.6001 5.33721 4.74724C5.08319 4.87667 4.87667 5.08319 4.74724 5.33721C4.6001 5.62599 4.6001 6.00403 4.6001 6.7601V13.2401C4.6001 13.9962 4.6001 14.3742 4.74724 14.663C4.87667 14.917 5.08319 15.1236 5.33721 15.2529C5.62599 15.4001 6.00403 15.4001 6.7601 15.4001H13.2401C13.9962 15.4001 14.3742 15.4001 14.663 15.2529C14.917 15.1236 15.1236 14.917 15.2529 14.663C15.4001 14.3742 15.4001 13.9962 15.4001 13.2401V12.0251" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.4002 8.6501V4.6001H11.3502M15.4002 4.6001L9.3252 10.6751" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M7.75 4H6.4C5.55992 4 5.13988 4 4.81902 4.16349C4.53677 4.3073 4.3073 4.53677 4.16349 4.81902C4 5.13988 4 5.55992 4 6.4V13.6C4 14.4401 4 14.8602 4.16349 15.181C4.3073 15.4632 4.53677 15.6927 4.81902 15.8365C5.13988 16 5.55992 16 6.4 16H13.6C14.4401 16 14.8602 16 15.181 15.8365C15.4632 15.6927 15.6927 15.4632 15.8365 15.181C16 14.8602 16 14.4401 16 13.6V12.25M11.5 4H16M16 4V8.5M16 4L9.25 10.75" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'OpenExternalIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped></style>